import service from "./service"

export default async (data) => {
    return service(data)
}
